const Sms = ({ innerRef, sender, time, subject, text, color, classNameContainer }) => {
  let classNameBgColor = 'bg-white';
  let classNameIconColor = '';

  switch (color) {
    case 'brand':
      classNameIconColor = 'fill-brand-400';
      break;

    case 'blue':
      classNameBgColor = 'bg-blue-50';
      classNameIconColor = 'fill-blue-500';
      break;

    case 'purple':
      classNameBgColor = 'bg-purple-50';
      classNameIconColor = 'fill-purple-500';
      break;

    case 'yellow':
      classNameBgColor = 'bg-yellow-50';
      classNameIconColor = 'fill-yellow-500';
      break;
  }

  return (
    <div
      ref={innerRef}
      className={`absolute top-[155px] -left-[36px] flex w-[370px] origin-top-left scale-65 items-center gap-2.5 rounded-md px-3 py-4 shadow-md lg:top-[255px] lg:-left-[66px] lg:scale-100 ${classNameBgColor || ''} ${classNameContainer || ''}`}
    >
      <div>
        <svg
          width="31"
          height="30"
          viewBox="0 0 31 30"
          className="w-[30px]"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            id="Vector"
            d="M26.5762 0.690918H4.28649C3.15006 0.692295 2.06056 1.14955 1.25699 1.96239C0.453409 2.77522 0.00136225 3.87727 9.80813e-07 5.02679V28.4405C-0.000242158 28.6031 0.044724 28.7626 0.129766 28.9006C0.214808 29.0386 0.3365 29.1496 0.480946 29.221C0.625087 29.2923 0.786106 29.3212 0.945692 29.3045C1.10528 29.2878 1.25703 29.2261 1.38368 29.1265L8.86703 23.2375H26.5762C27.7127 23.2361 28.8021 22.7788 29.6057 21.966C30.4093 21.1532 30.8614 20.0511 30.8627 18.9016V5.02679C30.8614 3.87727 30.4093 2.77522 29.6057 1.96239C28.8021 1.14955 27.7127 0.692295 26.5762 0.690918ZM15.4314 16.3001H7.71568C7.48831 16.3001 7.27025 16.2087 7.10948 16.0461C6.9487 15.8835 6.85838 15.6629 6.85838 15.4329C6.85838 15.2029 6.9487 14.9823 7.10948 14.8197C7.27025 14.6571 7.48831 14.5657 7.71568 14.5657H15.4314C15.6587 14.5657 15.8768 14.6571 16.0376 14.8197C16.1983 14.9823 16.2887 15.2029 16.2887 15.4329C16.2887 15.6629 16.1983 15.8835 16.0376 16.0461C15.8768 16.2087 15.6587 16.3001 15.4314 16.3001ZM23.147 9.36267H7.71568C7.48831 9.36267 7.27025 9.27131 7.10948 9.10868C6.9487 8.94605 6.85838 8.72548 6.85838 8.49549C6.85838 8.26551 6.9487 8.04494 7.10948 7.88231C7.27025 7.71968 7.48831 7.62832 7.71568 7.62832H23.147C23.3744 7.62832 23.5925 7.71968 23.7532 7.88231C23.914 8.04494 24.0043 8.26551 24.0043 8.49549C24.0043 8.72548 23.914 8.94605 23.7532 9.10868C23.5925 9.27131 23.3744 9.36267 23.147 9.36267Z"
            className={classNameIconColor}
          />
        </svg>
      </div>

      <div className="flex-1 text-black">
        <div className="flex items-center justify-between">
          <div className="text-base font-bold tracking-tight">{sender}</div>
          {time && <div className="text-sm text-gray-300">{time}</div>}
        </div>

        {subject && <div className="text-sm text-gray-600">{subject}</div>}

        <div className="text-sm text-gray-600">{text}</div>
      </div>
    </div>
  );
};
export default Sms;
